import * as React from "react";
import * as ReactDOM from "react-dom";
import "./index.css";
import registerServiceWorker from "./registerServiceWorker";

import App from "./components/App";
import Firebase, { FirebaseContext } from "./Firebase";

import * as META from "src/constants/meta";

class Root extends React.Component {
  public componentDidMount(): void {
    document.title = META.WINDOW_TITLE;
  }

  public render() {
    return <App />;
  }
}

ReactDOM.render(
  <FirebaseContext.Provider value={new Firebase()}>
    <Root />
  </FirebaseContext.Provider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx